import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=da0ec280&scoped=true&"
import script from "./MenuGroup.vue?vue&type=script&lang=js&"
export * from "./MenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./MenuGroup.vue?vue&type=style&index=0&id=da0ec280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ec280",
  null
  
)

export default component.exports